module.exports = __webpack_public_path__ + "img/coralclub-5.29fd3f25.png";